import { gsap, ScrollTrigger } from "./gsap";

export function createExperienceTimeline(scope: gsap.DOMTarget): void {
  gsap.fromTo(
    ".exp-line",
    { scaleY: 0 },
    {
      scaleY: 1,
      ease: "none",
      transformOrigin: "top center",
      scrollTrigger: { trigger: scope, start: "top 70%", end: "bottom 55%", scrub: true },
    }
  );

  gsap.utils.toArray<HTMLElement>(".exp-item").forEach((item) => {
    gsap.from(item.querySelector(".exp-card"), {
      opacity: 0,
      y: 48,
      duration: 0.85,
      scrollTrigger: { trigger: item, start: "top 84%" },
    });

    ScrollTrigger.create({
      trigger: item,
      start: "top 62%",
      end: "bottom 30%",
      onToggle: (self) => item.classList.toggle("exp-active", self.isActive),
    });
  });
}
